import React from "react";
import "./Loading.css";

type LogoProps = {
  style?: React.CSSProperties;
};

export function LogoSpinner({ style }: LogoProps) {
  const circles = [...Array(9)].map((_, index) => (
    <div key={index} className="lds-grid-item" />
  ));
  return (
    <div style={{ ...style }} className="lds-grid">
      {circles}
    </div>
  );
}

export default function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="loading-container-spinner">
        <LogoSpinner />
      </div>
    </div>
  );
}
